import { _deserializable } from '../_deserializable';

export class ResetPasswordRequest extends _deserializable {

  public confirmPassword: string;
  public email: string;
  public newPassword: string;
  public passwordResetToken: string;
}
